import { render, staticRenderFns } from "./publicityPage.vue?vue&type=template&id=54224800&"
import script from "./publicityPage.vue?vue&type=script&lang=js&"
export * from "./publicityPage.vue?vue&type=script&lang=js&"
import style0 from "./publicityPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54224800')) {
      api.createRecord('54224800', component.options)
    } else {
      api.reload('54224800', component.options)
    }
    module.hot.accept("./publicityPage.vue?vue&type=template&id=54224800&", function () {
      api.rerender('54224800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/publicityPage.vue"
export default component.exports